var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 24,
    viewBox: "0 0 141 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7773 15.0906H85.3699C84.195 18.5522 81.1462 20.6777 77.2871 20.6777C73.4401 20.6777 70.3912 18.5522 69.2066 15.0906H67.7887C68.9981 19.347 72.7116 22.147 77.2864 22.147C81.8191 22.147 85.5304 19.347 86.7765 15.0906H86.7773ZM77.2879 18.7876C81.2295 18.7876 83.7592 15.7878 83.7592 12C83.7592 8.21296 81.2295 5.21239 77.2879 5.21239C73.308 5.21239 70.8158 8.2122 70.8158 12C70.8158 15.7878 73.308 18.7876 77.2879 18.7876ZM77.2879 0C84.3173 0 89.3009 5.28808 89.3009 12C89.3009 18.7119 84.3173 24 77.2879 24C70.2209 24 65.2748 18.7119 65.2748 12C65.2748 5.28808 70.2209 0 77.2879 0ZM9.85548 10.5005C11.0836 10.5005 11.9013 9.22501 11.9013 7.91245C11.9013 6.59989 10.9343 5.4372 9.70693 5.4372H5.46751V10.5005H9.85623H9.85548ZM0 0.750899H9.33558C14.1332 0.750899 17.2578 3.67577 17.2578 7.91245C17.2578 11.8501 15.2862 14.0627 11.9763 14.8878L18.0012 23.2499H11.1578L5.46751 14.8499V23.2506H0V0.750142V0.750899ZM32.655 16.9876L30.0893 11.2877H30.0143L27.4111 16.9876H32.655ZM29.6054 0H30.5732L41.5067 23.2506H35.6304L34.514 20.9253H25.6991L24.6218 23.2506H18.7454L29.6054 0ZM52.8521 0C57.0908 0 60.0294 1.61231 62.4098 4.1254L58.6535 7.72472C57.0908 6.18886 55.0825 5.21239 52.8521 5.21239C48.8723 5.21239 46.3066 8.2122 46.3066 12C46.3066 15.7878 48.8723 18.7876 52.8521 18.7876C55.084 18.7876 57.0915 17.8119 58.6542 16.2753L62.2987 19.8754C60.0669 22.2363 56.9798 24 52.8521 24C45.7852 24 40.7648 18.7119 40.7648 12C40.7648 5.28808 45.7852 0 52.8514 0H52.8521ZM105.332 18.7876C109.274 18.7876 111.803 15.7878 111.803 12C111.803 8.21296 109.274 5.21239 105.332 5.21239C101.352 5.21239 98.8601 8.2122 98.8601 12C98.8601 15.7878 101.352 18.7876 105.332 18.7876ZM105.332 0C112.361 0 117.344 5.28808 117.344 12C117.344 18.7119 112.361 24 105.332 24C98.2652 24 93.3183 18.7119 93.3183 12C93.3183 5.28808 98.2652 0 105.332 0ZM126.904 0.750142L135.57 14.0998V14.0718H141V23.2506H135.31L126.607 9.86312V23.2506H121.139V0.750142H126.904ZM141 9.70416V11.9765H135.57V9.70416H141ZM141 5.33577V7.60815H135.57V5.33577H141ZM141 0.750142V3.24052H135.57V0.750142H141Z",
    fill: "url(#paint0_linear_133_2494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_2494",
    x1: -8.8125,
    y1: 24,
    x2: 13.792,
    y2: -42.3381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FF42B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D60FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9a9735d.svg";
export { ForwardRef as ReactComponent };